// frontend/src/components/ui/Button.jsx
// Updated with CSS variables for theming
import React from 'react';
import { cn } from '../../lib/utils';

export const Button = ({ variant = "default", size = "default", className, ...props }) => {
  // Base styles
  const baseClass = "btn font-medium rounded-md transition-colors focus:outline-none";
  
  // Variant styles using CSS variables
  const variantClasses = {
    primary: "bg-button-primary-bg text-button-primary-text hover:bg-button-primary-hover",
    secondary: "bg-button-secondary-bg text-button-secondary-text border border-border-primary hover:bg-button-secondary-hover",
    outline: "bg-transparent border border-border-primary text-text-primary hover:bg-background-tertiary",
    ghost: "bg-transparent hover:bg-background-tertiary text-text-primary",
    default: "bg-button-primary-bg text-button-primary-text hover:bg-button-primary-hover"
  };

  // Size styles
  const sizeStyles = {
    default: "h-10 px-4 py-2",
    sm: "h-9 rounded-md px-3 text-sm",
    lg: "h-12 px-6 py-3 text-lg",
    icon: "h-10 w-10 p-2 flex items-center justify-center"
  };

  return (
    <button
      className={cn(
        baseClass,
        variantClasses[variant] || variantClasses.default,
        sizeStyles[size] || sizeStyles.default,
        className
      )}
      {...props}
    />
  );
};